import React from "react";
import { Route, Routes } from "react-router-dom";
// import Login from "../containers/AuthPages/Login";
// import Login from "../containers/AuthPages/Login/Login.jsx";
import Register from "../containers/AuthPages/Register";
import ForgotPassword from "../containers/AuthPages/ForgotPassword/ForgotPassword";
import Dashboard from "./dashboard";
import FrontPage from "./frontPage";
// import ResetPassword from "../containers/AuthPages/ResetPassword";
import ResetPassword from "../containers/AuthPages/ResetPassword/ResetPassword.jsx";
// import VerifyUser from "../containers/AuthPages/VerifyUser";
import NewLogin from "../containers/AuthPages/login/Login.jsx";
import JoinUs from "../containers/AuthPages/joinus/JoinUs.jsx";
import TermsConditionsPage from "../containers/AuthPages/TermsConditions/TermsConditions.jsx";
import VerifyUser from "../containers/AuthPages/verifyUser/VerifyUser.jsx";

const Routers = () => {
  return (
    <>
      <Routes>
        <Route path="/*" index element={<FrontPage />} />
        <Route path="/dashboard/*" element={<Dashboard />} />
        <Route path="/login" element={<NewLogin />} />
        <Route path="/join-us" element={<JoinUs />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login/:token" element={<VerifyUser />} />
        <Route path="/resetpassword/:token" element={<ResetPassword />} />
        <Route path="/termsconditions" element={<TermsConditionsPage />} />
      </Routes>
    </>
  );
};

export default Routers;
